<template>
  <div :class="'custom-tooltip-status0'">
    <div class="tooltip_view_box">
      <template>
        <div class="close_status1"
             @click="hideCustomTooltip">
          关闭
        </div>

        <div class="title">
          {{ tData.factory_name }}
        </div>

        <div class="content_box">
          <div>产品：{{ tData?.census_data?.product_count }}个</div>
          <div class="content_text">产品事件：{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}{{
              tData?.census_data?.event
            }}{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}{{
              tData?.census_data?.event
            }}{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}{{
              tData?.census_data?.event
            }}{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}{{
              tData?.census_data?.event
            }}{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}{{
              tData?.census_data?.event
            }}{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}{{
              tData?.census_data?.event
            }}{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}{{
              tData?.census_data?.event
            }}{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}{{ tData?.census_data?.event }}
          </div>
        </div>
      </template>
    </div>
  </div>

</template>


<script>
export default {
  props: {
    tData: {
      type: Object,
      default: {}
    },
    timeLabelLocal: {
      type: String,
      default: ''
    },
    hideCustomTooltip: {
      type: Function,
      default: () => {
      }
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
  beforeDestroy() {
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>

.tooltip_view_box {
  padding: 0 20px;

  .close_status1 {
    position: absolute;
    right: 7px;
    cursor: pointer;
    pointer-events: auto; /* 允许关闭按钮接收鼠标事件 */
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    padding-top: 10px;
  }

  .content_box {
    height: 190px;
    display: flex;
    flex-direction: column;
    padding-top: 12px;
    gap: 12px;

    .content_text{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 6; /* 根据需要调整行数 */
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-word;
    }
  }

}


.custom-tooltip-status0 {
  width: 580px;
  height: 270px;
  background: url(../../assets/_s-image_map_operation.png) no-repeat;
  background-size: 580px 270px;
}
</style>